import { Debt } from '@axo/shared/data-access/types';
import { refinanceableDebtsTypes } from '../globals';

type GetCleanDebts = {
  debts?: Partial<Debt>[];
};

export const getCleanDebts = ({ debts }: GetCleanDebts) =>
  debts?.map((debt) => {
    if (
      debt.Type &&
      !refinanceableDebtsTypes.includes(debt.Type) &&
      debt.RefinanceAmount &&
      debt.RefinanceAmount > 0
    )
      return {
        ...debt,
        RefinanceAmount: undefined,
      };

    return debt;
  }) || [];
